import { forwardRef } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';
import type { SetRequired } from 'type-fest';

import { cls } from '@/utils/cls';

import { TaskPriority } from '../entities/task-priority';

const taskPriorityBadge = tv({
  base: 'inline-block rounded-full px-2 py-1 text-xs font-normal leading-none',
  variants: {
    priority: {
      [TaskPriority.LOW]: 'bg-green-50 text-green-700',
      [TaskPriority.MEDIUM]: 'bg-amber-50 text-yellow-700',
      [TaskPriority.HIGH]: 'bg-red-50 text-red-700',
    } satisfies Record<TaskPriority, string>,
  },
});

export type TaskPriorityBadgeProps = { className?: string } & SetRequired<
  VariantProps<typeof taskPriorityBadge>,
  'priority'
>;

const TaskPriorityBadge = forwardRef<HTMLDivElement, TaskPriorityBadgeProps>(
  ({ priority, className }, ref) => (
    <div ref={ref} className={cls(taskPriorityBadge({ priority }), className)}>
      {priority}
    </div>
  ),
);

TaskPriorityBadge.displayName = 'TaskPriorityBadge';
export { TaskPriorityBadge };
